import React, { type FC } from 'react'
import { ActiveFiltersContainer, StyledChip } from './Filters.style'
import ClearIcon from '@mui/icons-material/Clear'
import { RemoveActiveLabelFilterAction, SetMeterActivePageAction } from '../../../redux/meter-table/meter-table-actions'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { type RootState } from '../../../redux/store'
import { UpdateLabelFilterChangedAction } from '../../../redux/data/data-actions'

export const ActiveLabelFilters: FC = () => {
  const dispatch = useAppDispatch()

  const labelFilters = useAppSelector<string[]>((state: RootState) => state.data.labelFilters)

  const handleDelete = (filter: string): void => {
    dispatch(RemoveActiveLabelFilterAction({ data: filter }))
    dispatch(UpdateLabelFilterChangedAction({ filter }))
    dispatch(SetMeterActivePageAction({ activePage: 1 }))
  }

  return (
        <ActiveFiltersContainer>
            {labelFilters.map((filter) => (
                <StyledChip deleteIcon={<ClearIcon/>} key={filter} label={filter} onDelete={() => {
                  handleDelete(filter)
                }}/>
            ))}
        </ActiveFiltersContainer>)
}
